import { TransactionsContextType } from "@zenith/context/global-context/types";
import { memo } from "react";
import { shouldShow, truncateText } from "@zenith/utils/TransactionDisplayHelpers";

export interface CashTransactionDetailsProps {
  transaction: TransactionsContextType;
}

const CashTransactionDetails = memo(function CashTransactionDetails(
  props: CashTransactionDetailsProps
) {
  const { transaction } = props;

  return (
    <>
      {shouldShow(transaction?.description) && (
        <div className="mb-2 flex justify-between">
          <p className="text-neutral-600">Description</p>
          <div className="w-80">
            <p className="text-right font-medium text-neutral-900 break-words">
              {truncateText(transaction?.description)}
            </p>
          </div>
        </div>
      )}
    </>
  );
});

export default CashTransactionDetails;